export type ToastType = 'success' | 'danger' | 'warning';

export interface ToastBaseComponent {
  data: ToastData;
}

export interface ToastData {
  type: ToastType;
  title?: string;
  messages?: string;
  duration?: number;
}
